import { combineReducers } from 'redux';

import app from './../@core/redux/reducers/app/index';

export default combineReducers({
    app
});